import Validation from "@/classes/global/Validation";
import ValidationBase from "@/classes/global/ValidationBase";

export default class FreightBookingValidation extends ValidationBase {

    constructor() {

        super();

        this.shipmentRef = new Validation();
        this.shipmentShipperRef = new Validation();
        this.shipmentConsigneeRef = new Validation();
        this.shipmentCarrier = new Validation();
        this.shipmentServiceType = new Validation();
        this.shipmentBillingParty = new Validation();
        this.shipmentBillingPartyDetail = new Validation();
        this.shipmentDescription = new Validation();
        this.shipmentPickupDate = new Validation();
        this.shipmentDeliveryDate = new Validation();
        this.shipmentDeliveryTime = new Validation();
        this.shipmentCurrency = new Validation();
        this.shipmentValue = new Validation();
        this.shipmentComments = new Validation();
        this.totalPieces = new Validation();
        this.totalWeight = new Validation();

    }


        // this.validationMessages = ['Required', 'Max Number 20', 'Incorrect Format', 'Enter Search Text'];
        // this.shipperName = new Validation();
        // this.shipperAddressLine1 = new Validation();
        // this.shipperAddressLine2 = new Validation();
        // this.shipperCity = new Validation();
        // this.shipperCounty = new Validation();
        // this.shipperPostcode = new Validation();
        // this.shipperCountry = new Validation();
        // this.shipperVatNumber = new Validation();
        // this.shipperContactFullName = new Validation();
        // this.shipperContactTitle = new Validation();
        // this.shipperContactFirstName = new Validation();
        // this.shipperContactLastName = new Validation();
        // this.shipperContactPhone = new Validation();
        // this.shipperContactEmail = new Validation();
        // this.shipperContactDepartment = new Validation();
        // this.consigneeName = new Validation();
        // this.consigneeAddressLine1 = new Validation();
        // this.consigneeAddressLine2 = new Validation();
        // this.consigneeCity = new Validation();
        // this.consigneeCounty = new Validation();
        // this.consigneePostcode = new Validation();
        // this.consigneeCountry = new Validation();
        // this.consigneeVatNumber = new Validation();
        // this.consigneeContactFullName = new Validation();
        // this.consigneeContactTitle = new Validation();
        // this.consigneeContactFirstName = new Validation();
        // this.consigneeContactLastName = new Validation();
        // this.consigneeContactPhone = new Validation();
        // this.consigneeContactEmail = new Validation();

}
